import React, {
    FC, useState, KeyboardEvent, useEffect
} from 'react';
import {
    Slider, NumberField, Flex, View
} from '@adobe/react-spectrum';
import { toast } from 'react-toastify';

export interface IInputSliderFieldProps {
    defaultValue?: number;
    value?: number;
    width?: string;
    label: string;
    min: number;
    max: number;
    step: number;
    onChange: (value: number) => void;
}

export const InputSliderField: FC<IInputSliderFieldProps> = ({
    defaultValue, value, width, label, min, max, step, onChange
}) => {
    const [sliderValue, setSliderValue] = useState(defaultValue);

    useEffect(() => {
        if (value !== null) setSliderValue(value);
    }, [value]);

    const onUpdate = (v: number) => {
        if (v > max || v < min) {
            toast.warning(`Value must be between ${min} and ${max}`);
            setSliderValue(max);
            onChange(max);
        } else {
            setSliderValue(v);
            onChange(v);
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            // @ts-ignore
            onUpdate(parseFloat(e.currentTarget.value));
        }
    };

    return (
        <Flex
            direction="row"
            gap="size-100"
            alignItems="center"
        >
            <Slider
                width={width}
                minValue={min}
                maxValue={max}
                step={step}
                label={label}
                value={sliderValue}
                onChange={onUpdate}
                showValueLabel={false}
            />
            <View flex />
            <NumberField
                width="size-700"
                aria-label="Sensibility"
                onChange={onUpdate}
                onKeyDown={handleKeyDown}
                value={sliderValue}
                step={step}
                minValue={min}
                maxValue={max}
                hideStepper
            />
        </Flex>
    );
};

InputSliderField.defaultProps = {
    value: null,
    defaultValue: 0,
    width: 'size-2000'
};
